import distance from "jaro-winkler";

export function checkClientNames(clients, client) {
    // distance() - string similarity function using the Jaro-Winkler distance metric. Returns a number between 0 and 1
    const removeSpecialChars = (string) => { return string.replace(/[\"\(\)\.-]/g, '').toLowerCase(); };
    const removeSpecialCharsAndSpaces = (string) => { return string.replace(/[\s+\"\(\)\.-]/g, '').toLowerCase(); };

    // similarClientsA - prepare input client name and clients table by remove special chars and spacen and lowerCase() then return client with Jaro-Winkler distance > 0.8
    const similarClientsA = clients.filter(c => {
        const tableClient = removeSpecialCharsAndSpaces(c.name);
        const inputClient = removeSpecialCharsAndSpaces(client.name);
        return distance(tableClient, inputClient, { caseSensitive: false }) > 0.8;
    }).map(c => c.name);

    // similarClientsB - if input name is single word - check if clients table contains exact or very similar (Jaro-Winkler distance > 0.9) input name
    const similarClientsB = clients.filter(c => {
        const tableClient = removeSpecialChars(c.name);
        const inputClient = removeSpecialChars(client.name);
        const tableClientWords = tableClient.split(" ");

        const matchingWords = tableClientWords.filter(word => distance(word, inputClient) > 0.9 && word.length === inputClient.length);
        return matchingWords.length != 0;
    }).map(c => c.name);

    const similarClientNames = client.name.split(" ").length == 1 ? similarClientsA.concat(similarClientsB.filter(s => !similarClientsA.find(sm => sm == s))) : similarClientsA;
    return similarClientNames;
}

export function isSameClient(clients, field, client) {
    let data = angular.copy(clients);
    const clientCopy = angular.copy(client);
    if (field == 'taxId') {
      data = clients.filter(c => c.taxId.toLowerCase() != 'missing');
    }

    if (field === 'name') {
        data.map(client => (client.additionalInfo ? "(" + client.additionalInfo + ") " : "") + client.name);
        clientCopy.name = (clientCopy.additionalInfo ? "(" + clientCopy.additionalInfo + ") " : "") + clientCopy.name;
    }
    return data.some(c => c[field].toLowerCase() === clientCopy[field].toLowerCase());
}

export function getClientWarnings(clients, client) {
    const similarClientNames = checkClientNames(clients, client);
    const sameTaxes = clients.filter(c => c.taxId.toLowerCase() == client.taxId.toLowerCase())
      .filter(c => c.taxId.toLowerCase() != 'missing')
      .map(c => c.name);

    const anySimilarClientNames = similarClientNames.length > 0;
    const anySameTax = sameTaxes.length > 0;
    const anySameName = isSameClient(clients, 'name', client);

    if (anySimilarClientNames || anySameTax || anySameName)
        return {
            sameTax: isSameClient(clients, 'taxId', client) && sameTaxes[0],
            sameName: isSameClient(clients, 'name', client) && similarClientNames.find(d => d.toLowerCase() == client.name.toLowerCase()),
            similarNames: similarClientNames.length > 0 && similarClientNames,
            blocked: isSameClient(clients, 'taxId', client) || isSameClient(clients, 'name', client),
            any: similarClientNames.length > 0 || sameTaxes.length > 0
        };
    else
        return {};
}